import { ActiveFacetsEffects } from './active-facets.effect';
import { FacetsEffects } from './facets.effect';
import { ProductSearchEffects } from './product-search.effects';
import { SearchSuggestionsEffects } from './search-suggestions.effects';

export const effects: any[] = [FacetsEffects, ActiveFacetsEffects, SearchSuggestionsEffects, ProductSearchEffects];
